import { render, staticRenderFns } from "./monresto.vue?vue&type=template&id=ca775f4c&"
import script from "./monresto.vue?vue&type=script&lang=js&"
export * from "./monresto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports